module.exports = __webpack_public_path__ + "static/media/LightningIcon.475b99ee.svg";